import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Heading } from '@wix/design-system';
import { ArrowDownRight } from 'wix-ui-icons-common';
import s from './AnonymousFooterBanner.scss';
import { withInjectedRootStore, RootStore } from 'providers';
import { Experiments } from 'enums';

interface AnonymousFooterBannerProps {
  rootStore: RootStore;
}

const AnonymousFooterBannerComp: React.FC<AnonymousFooterBannerProps> = ({
  rootStore,
}) => {
  const { t } = useTranslation();
  const {
    getSignInRedirectionLink,
    appContext: { biLogger },
    experiments,
  } = rootStore.appStore;
  const isNewStudioAnonymousContentEnabled =
    experiments[Experiments.NewStudioAnonymousContent] === 'true';

  const handleAnonymousCtaClick = () => {
    const targetUrl = getSignInRedirectionLink();
    biLogger.logAnonymousCtaClick({
      targetUrl,
      ctaName: 'studio-anonymous-bottom-cta',
    });
    window.open(targetUrl, '_self');
  };

  return (
    <Box
      direction='vertical'
      height='250px'
      className={s.wixStudioBackgroundColor}
      align='center'
      gap='SP5'
    >
      <Heading appearance='H1' light>
        {isNewStudioAnonymousContentEnabled
          ? t('studio_package_picker.anon.sendoff.title')
          : t('studio_package_picker.anon.banner.title')}
      </Heading>
      <Button
        fullWidth={false}
        skin='light'
        onClick={handleAnonymousCtaClick}
        className={s.anonymousCta}
        size='large'
        suffixIcon={<ArrowDownRight className={s.arrowBtnRotate} />}
      >
        {isNewStudioAnonymousContentEnabled
          ? t('studio_package_picker.anon.CTA')
          : t('studio_package_picker.anon.banner.CTA')}
      </Button>
    </Box>
  );
};

export const AnonymousFooterBanner = withInjectedRootStore(
  AnonymousFooterBannerComp,
);
